import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
    TipuriTaxeNedebitabileInterface,
    UpdateTipurTaxeNedebitabileInterface,
} from './tipuri-taxe-nedebitabile.interface';

@Injectable({
    providedIn: 'root',
})
export class TipuriTaxeNedebitabileService {
    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;

    private getTipuriTaxeNedebitabile =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriTaxeNedebitabile
            .getTipuriTaxeNedebitabile;
    private getTipuriTaxeNedebitabileDT =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriTaxeNedebitabile
            .getTipuriTaxeNedebitabileDT;
    private getTipTaxaNedebitata =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriTaxeNedebitabile
            .getTipTaxaNedebitata;
    private updateTipuriTaxeNedebitabile =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriTaxeNedebitabile
            .updateTipuriTaxeNedebitabile;
    private updateStatusTipuriTaxeNedebitabile =
        this.basePath +
        environment.interop.payments.nomenclatoare.tipuriTaxeNedebitabile
            .updateStatusTipuriTaxeNedebitabile;

    constructor(private http: HttpClient) { }

    getTaxeNedebitabileDT() {
        return this.http.get(this.getTipuriTaxeNedebitabileDT, this.httpOptions);
    }

    updateTaxeNedebitate(data: UpdateTipurTaxeNedebitabileInterface) {
        return this.http.put(
            this.updateTipuriTaxeNedebitabile + data.id,
            data,
            this.httpOptions
        );
    }

    changeStatusActive(id: number) {
        return this.http.get(
            this.updateStatusTipuriTaxeNedebitabile + id,
            this.httpOptions
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
